import m from "../../es2015/themes/spiritedaway";
window.am4themes_spiritedaway = m;


//////////////////
// WEBPACK FOOTER
// ./themes/spiritedaway.js
// module id = null
// module chunks = 